import { toothMovement, wasmModule } from "@/gluelayer"
import type { FC } from "react"
import { useTranslation } from "react-i18next"

import { setAligementBtnDisabled } from "@/UDTreat/udTreatSlice"
import { useAppDispatch } from "@/core/app/hooks"
import UButton from "../../../../ui-component/components/UButton/UButton"
import DialogBox from "../DialogBox/dialogBox"
const PassIprPopup: FC = ({
  hasObj,
  setHasObj,
}: {
  hasObj: { hasIPR: number; hasPA: number }
  setHasObj: (arg: { hasIPR: number; hasPA: number }) => void
}) => {
  const { t } = useTranslation("common")
  //hasObj.hasIPR || hasObj.hasPA
  const dispatch = useAppDispatch()

  return (
    <DialogBox
      open={hasObj.hasPA > 0 || hasObj.hasIPR > 0}
      title={t("treat.passIprPopup.title")}
      content={
        <p style={{ margin: "0", fontSize: "14px" }}>
          {hasObj.hasIPR && hasObj.hasPA
            ? `${t("treat.passIprPopup.fullcontent")}`
            : `${t("treat.passIprPopup.content")}${
                hasObj.hasPA ? "passive aligner" : "IPR"
              }`}
        </p>
      }
      actions={
        <>
          <UButton
            onClickHandler={() => {
              if (!wasmModule.isFinishedOpencase) return false
              const moveToothModule =
                wasmModule.wrapInstance.GetMoveToothModule()
              if (!moveToothModule) return false
              // toothMovement.dealWithExistIprOrPAPrompt(false) // invalid action.
              // moveToothModule.AfterIPRorPassiveRefreshStage(false)
              setHasObj({ hasIPR: 0, hasPA: 0 })
              dispatch(setAligementBtnDisabled(false))
            }}
            variant={"text"}
            btnText={"Cancel"}
          />
          <UButton
            onClickHandler={() => {
              if (!wasmModule.isFinishedOpencase) return false
              const moveToothModule =
                wasmModule.wrapInstance.GetMoveToothModule()
              if (!moveToothModule) return false
              toothMovement.dealWithExistIprOrPAPrompt(true)
              console.log("After dealWithExistIprOrPAPrompt: ");
              (window as any).updateStagesCallback?.();
              //moveToothModule.AfterIPRorPassiveRefreshStage(true)

              setHasObj({ hasIPR: 0, hasPA: 0 })

              dispatch(setAligementBtnDisabled(false))
            }}
            variant={"contained"}
            btnText={t("treat.lockPopUp.okbtn")}
          />
        </>
      }
    />
  )
}
export default PassIprPopup
